/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DefualtImageFromJSON, DefualtImageToJSON } from './DefualtImage';
export function GetDefaultImagesResponseDataFromJSON(json) {
    return GetDefaultImagesResponseDataFromJSONTyped(json, false);
}
export function GetDefaultImagesResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        defaultImages: !exists(json, 'default_images')
            ? undefined
            : json['default_images'].map(DefualtImageFromJSON)
    };
}
export function GetDefaultImagesResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        default_images: value.defaultImages === undefined ? undefined : value.defaultImages.map(DefualtImageToJSON)
    };
}
